import { useState } from 'react';
import Input from '../../components/Inputs/Input/Input';
import { MASK } from '../../constants/mask';
import LoaderInline from '../../components/Loader/LoaderInline';
import { textStyles } from '../../constants/textStyles';
import Button from '../../components/Button/Button';
import sendVerifyCode from '../../api/resources/sendVerifyCode';
import alert from '../../helpers/alert';
import accessVerifyCode from '../../api/resources/accessVerifyCode';
import HookForm from '../../components/HookForm/HookForm';
import deleteAccount from '../../api/auth/deleteAccount';

const TIMEOUT_FOR_RESEND = 30;

const DeleteAccount = () => {
  const [loading, setLoading] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [phone, setPhone] = useState(null);
  const [countDown, setCountDown] = useState(TIMEOUT_FOR_RESEND);
  const [countDownInterval, setCountDownInterval] = useState(null);
  const sendOtp = () => {
    setLoading(true);
    sendVerifyCode({
      phone,
    })
      .then(() => {
        setIsCodeSent(true);
        clearInterval(countDownInterval);
        setCountDown(TIMEOUT_FOR_RESEND);

        const interval = setInterval(() => {
          setCountDown((prev) => {
            if (prev === 0) {
              clearInterval(countDownInterval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
        setCountDownInterval(interval);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkCode = (values) => {
    setLoading(true);
    accessVerifyCode({
      phone,
      code: values.code,
    }).then((res) => {
      if (res?.data) {
        deleteAccount
          .then(() => {
            setIsFinished(true);
          })
          .catch(() => {
            alert.error('ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°. ÐÐ¾Ð²ÑÐ¾ÑÐ¸ÑÐµ Ð¿Ð¾Ð¿ÑÑÐºÑ.');
          })
          .finished(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
        alert.error('ÐÐµÐ²ÐµÑÐ½ÑÐ¹ ÐºÐ¾Ð´');
      }
    });
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '90vh',
        }}
      >
        <LoaderInline />
      </div>
    );
  }

  if (isFinished) {
    return (
      <div
        style={{
          padding: '50px 15px',
          maxWidth: 500,
          margin: '0 auto',
        }}
      >
        <h1
          style={{
            ...textStyles.formTitle,
            marginBottom: 20,
          }}
        >
          ÐÐ¸ÑÐ½ÑÐ¹ ÐºÐ°Ð±Ð¸Ð½ÐµÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ {phone} ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ´Ð°Ð»ÐµÐ½.
        </h1>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: '50px 15px',
        maxWidth: 500,
        margin: '0 auto',
      }}
    >
      <h1
        style={{
          ...textStyles.formTitle,
          marginBottom: 20,
        }}
      >
        Ð£Ð´Ð°Ð»ÐµÐ½Ð¸Ðµ ÑÑÐµÑÐ½Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ Doscar
      </h1>
      <Input
        mask={MASK.PHONE}
        label="ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°"
        value={phone}
        onChange={(e) => {
          setPhone(e?.target?.value);
        }}
        disabled={isCodeSent}
      />
      {isCodeSent ? (
        <>
          <HookForm
            grid={{
              display: 'grid',
              gap: '10px',
              gridTemplateColumns: '1fr',
            }}
            onSubmit={checkCode}
            inputs={[
              {
                name: 'code',
                label: 'ÐÐ¾Ð´ Ð¸Ð· Ð¡ÐÐ¡',
                type: 'text',
                required: true,
                rules: {
                  required: true,
                },
                validate: (value) => {
                  if (value.length !== 4) {
                    return 'ÐÐµÐ²ÐµÑÐ½ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ ÐºÐ¾Ð´Ð°';
                  }
                  return true;
                },
              },
            ]}
            customData={(submit) => (
              <>
                {countDown ? (
                  <p style={{ textAlign: 'center' }}>ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ¾Ð´ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾ ÑÐµÑÐµÐ· {countDown} ÑÐµÐºÑÐ½Ð´</p>
                ) : (
                  <Button text={'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ¾Ð´ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾'} onClick={sendOtp} />
                )}
                <br />
                <Button text="ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ" fill full onClick={submit} />
              </>
            )}
          />
        </>
      ) : null}
      {!isCodeSent ? (
        <>
          <br />
          <Button fill full text={'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ'} onClick={sendOtp} />
        </>
      ) : null}
    </div>
  );
};

export default DeleteAccount;
